export const EmailFieldData = {
  formControlName: 'email',
  id: 'grit-field-email',
  type: 'text',
  label: 'Email address',

  prefixIcon: {
    iconName: 'email',
  },
  validationList: [
    {
      validatorName: 'missingCharacter',
      errorKey: 'missingAtSymbol',
      args: ['@'],
      message: 'Your email address is missing the @ symbol.',
    },
    {
      validatorName: 'missingCharacter',
      errorKey: 'missingPeriod',
      args: ['.'],
      message: 'Your email address is missing a period ( . ).',
    },
    {
      validatorName: 'invalidCharacter',
      errorKey: 'invalidSpace',
      args: [' '],
      message: "Your email address can't contain any spaces.",
    },
    {
      errorKey: 'maxCharacterCount',
      args: ['@', 1],
      message: 'Your email address can only have one at ( @ ) symbol.',
    },
    {
      errorKey: 'pattern',
      args: ['^((?![\\!\\#\\$\\%\\^\\&\\*\\(\\)\\-=\\,]).)*$'],
      message:
        "Your email address can't contain special characters other than at ( @ ), period ( . ), dash ( - ), underscore ( _ ) or plus ( + ).",
    },
    {
      validatorName: 'pattern',
      errorKey: 'general',
      args: ['^(.+)@(.+)\\.(.{2,})$'],
      message:
        'Please make sure your email address is formatted correctly. Example: yourname@domain.com',
    },
  ],
  requiredMessage: 'Your email address is required to process the application.',
  hint: "We'll send you updates on your application at this email address.",
};
